export default {
  Colorpicker: {
    mounted() {
      const colorInput = this.el.querySelector('input[type=color]');
      const hexTextInput = this.el.querySelector('input[type=text]');

      // If the two values don't match, it means the field is blank
      if (colorInput.value !== hexTextInput.value) {
        if (hexTextInput.value === '') {
          // If hexTextInput is blank, no default_value was provided.
          // In which case, use the Color input's value
          hexTextInput.value = colorInput.value;
        } else {
          // Use the value in hexTextInput which would be the default value
          colorInput.value = hexTextInput.value;
        }
      }

      colorInput.addEventListener('input', (e) => {
        hexTextInput.value = e.target.value.toUpperCase();
      });

      hexTextInput.addEventListener('input', (e) => {
        let userInput = e.target.value;

        // If user has not added #, add it (input masking)
        if (userInput[0] !== '#') {
          userInput = `#${userInput}`;
          e.target.value = userInput;
        }

        // Confirm given input is a valid hex code
        if (/^#[0-9A-F]{6}$/i.test(userInput)) {
          colorInput.value = userInput.toUpperCase();
        }
      });
    },
  },
};
